import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "推廣賺錢",
  cinema_referralDesc: "分享專屬連結，邀請好友註冊並獲得獎勵",
  cinema_referralLinkTitle: "我的推廣連結",
  cinema_referralLinkDesc: "好友透過此連結註冊後，將自動繫結邀請關係",
  cinema_referralRulesTitle: "推廣規則說明",
  cinema_referralRulesCoins: "好友透過專屬連結註冊後，您可獲得金幣獎勵。金幣僅用於站內看片消費，不能兌換現金或申請提現。",
  cinema_referralRulesCommission: "好友充值後，您可按規則獲得充值分成。僅充值分成可提現，累計達到 ¥100 後可申請透過 USDT 提現。",
  cinema_copyLink: "複製連結",
  cinema_inviteCodeLabel: "分享碼",
  cinema_inviteRuleTitle: "邀請獎勵",
  cinema_inviteRuleNormal: "普通會員每成功邀請一位好友註冊，可獲得 20 金幣，獎勵自動計入金幣流水。",
  cinema_distributorOverview: "分銷概覽",
  cinema_availableCommission: "可提現佣金",
  cinema_totalCommission: "累計佣金",
  cinema_pendingWithdrawal: "待處理提現",
  cinema_withdrawnAmount: "累計已提現",
  cinema_firstLevelRate: "一級分成",
  cinema_secondLevelRate: "二級分成",
  cinema_todayBrowse: "瀏覽",
  cinema_todayRegister: "註冊",
  cinema_todayRecharge: "充值筆數",
  cinema_todayRechargeAmount: "充值金額",
  cinema_commissionAmount: "佣金",
  cinema_registerDetails: "註冊明細",
  cinema_rechargeDetails: "充值明細",
  cinema_inviteRewards: "邀請獎勵流水",
  cinema_goWithdraw: "申請提現",
  cinema_noReferralData: "暫無推廣資料",
  cinema_referralLoadFailed: "推廣資料載入失敗，請稍後重試",
  cinema_loginToPromote: "登入後生成你的專屬推廣連結",
  cinema_totalEarnings: "累計收益",
  cinema_withdrawable: "可提現",
  cinema_frozen: "凍結中",
  cinema_invitedCount: "邀請人數",
  cinema_coinUnit: "金幣",
  cinema_people: "人",
  cinema_conversionStats: "推廣轉化統計",
  cinema_allDatesTotal: "全部日期合計",
  cinema_selectedDatesTotal: "所選日期合計",
  cinema_conversionStatsDesc: "按天檢視瀏覽、註冊、充值和實際分成",
  cinema_colDate: "日期",
  cinema_colPv: "瀏覽人數",
  cinema_colBrowseCount: "瀏覽次數",
  cinema_colRegister: "註冊",
  cinema_colRechargeUsers: "充值人數",
  cinema_colRechargeOrders: "充值訂單",
  cinema_colPaidAmount: "實付金額",
  cinema_colCommission: "實際分成",
  cinema_colRegisterRate: "註冊率",
  cinema_colRechargeRate: "充值率",
  cinema_commissionRateTitle: "佣金比例",
  cinema_currentRateLabel: "當前實際佣金分成比例",
  cinema_baseRate: "基礎比例",
  cinema_currentRate: "當前比例",
  cinema_earningsRecord: "收益記錄",
  cinema_inviteDetail: "邀請明細",
  cinema_allEarnings: "全部收益記錄",
  cinema_filterAll: "全部",
  cinema_filterPending: "待結算",
  cinema_filterSettled: "已結算",
  cinema_earningsDate: "時間",
  cinema_earningsType: "型別",
  cinema_earningsUser: "使用者",
  cinema_earningsAmount: "收益",
  cinema_earningsStatus: "狀態",
  cinema_statusSettled: "已結算",
  cinema_statusPending: "待結算",
  cinema_noEarningsRecords: "暫無相關記錄",
  cinema_referralUser: "使用者",
  cinema_referralRegDate: "註冊時間",
  cinema_referralRecharged: "累計充值",
  cinema_referralEarned: "我的收益",
  cinema_startDate: "開始日期",
  cinema_endDate: "結束日期",
  cinema_query: "查詢",
  cinema_dateRangeError: "開始日期不能晚於結束日期",
  cinema_brand: "黃果TV",
  cinema_language: "語言",
  cinema_tagline: "AI原創短劇，無限精彩",
  cinema_navHome: "首頁",
  cinema_navCategories: "排行榜",
  cinema_rankingTitle: "排行榜",
  cinema_rankingAll: "全部",
  cinema_rankingLoading: "榜單載入中...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} 部劇 · 播放 {{views}} 次",
  cinema_rankingTotal: "總排行",
  cinema_rankingMonth: "月排行",
  cinema_rankingWeek: "周排行",
  cinema_rankingLatest: "最新更新",
  cinema_rankingCreator: "投稿排行",
  cinema_creatorLabel: "使用者投稿",
  cinema_rankingEmpty: "暫無上榜劇集",
  cinema_navMyList: "熱播",
  cinema_soundGuideTitle: "點選這裡開啟聲音",
  cinema_soundGuideAction: "開啟聲音",
  cinema_soundGuideDismiss: "關閉聲音引導",
  cinema_navHistory: "歷史",
  cinema_navAds: "賺幣",
  cinema_adsTitle: "廣告推薦",
  cinema_adsSubtitle: "發現更多精彩內容",
  cinema_adFeatured: "精選推薦",
  cinema_adOpen: "立即檢視",
  cinema_adsEmpty: "暫無廣告",
  cinema_adsLoadFailed: "廣告載入失敗，請稍後重試",
  cinema_earnTitle: "賺金幣",
  cinema_earnSubtitle: "每天簽到，金幣輕鬆拿",
  cinema_earnBalance: "我的金幣",
  cinema_checkInTitle: "每日簽到",
  cinema_checkInSubtitle: "連續簽到可領取更多金幣",
  cinema_checkInDay: "第{{day}}天",
  cinema_checkInToday: "今天",
  cinema_checkInClaim: "簽到領 {{points}} 金幣",
  cinema_checkInClaimed: "今日已簽到",
  cinema_checkInLogin: "登入後簽到",
  cinema_checkInSuccess: "簽到成功，獲得 {{points}} 金幣",
  cinema_checkInFailed: "簽到失敗，請檢查網路後重試",
  cinema_checkInNoReward: "該裝置今日簽到獎勵已領取",
  cinema_checkInStreak: "連續簽到",
  cinema_checkInStreakValue: "{{days}} 天",
  cinema_checkInTotal: "簽到累計",
  cinema_checkInTotalValue: "{{points}} 金幣",
  cinema_checkInLoadFailed: "簽到資訊載入失敗",
  cinema_retry: "重新載入",
  cinema_moreEarnWays: "更多賺幣方式",
  cinema_inviteEarnTitle: "邀請好友賺金幣",
  cinema_inviteEarnDesc: "好友註冊成功，即可獲得邀請獎勵",
  cinema_goInvite: "去邀請",
  cinema_earnCoinsTitle: "賺幣中心",
  cinema_earnCoinsBalance: "我的金幣",
  cinema_earnCoinsSignInStreak: "您已連續簽到{{count}}天",
  cinema_earnCoinsCheckIn: "簽到",
  cinema_earnCoinsCheckedIn: "已簽到",
  cinema_earnCoinsTomorrow: "明日再來",
  cinema_earnCoinsInviteTitle: "邀請一位好友獲取",
  cinema_earnCoinsInviteCode: "我的邀請碼",
  cinema_earnCoinsGoInvite: "去邀請",
  cinema_earnCoinsLimitedTask: "限時任務",
  cinema_earnCoinsTimeLeft: "倒計時",
  cinema_earnCoinsNewbieTask: "新手任務",
  cinema_earnCoinsDailyTask: "日常任務",
  cinema_earnCoinsRecommendations: "相關推薦",
  cinema_earnCoinsAdTask: "觀看廣告",
  cinema_earnCoinsAdTaskDesc: "完成廣告任務即可獲得更多金幣",
  cinema_earnCoinsGoWatch: "觀看廣告",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "第{{day}}天",
  cinema_earnCoinsToday: "今天",
  cinema_earnCoinsCoinUnit: "金幣",
  cinema_earnCoinsAdCurrent: "當前任務",
  cinema_earnCoinsAdLocked: "待解鎖任務",
  cinema_earnCoinsTaskCompleted: "已完成",
  cinema_limitedRechargeTaskTitle: "限時完成首充",
  cinema_limitedRechargeTaskAction: "去充值",
  cinema_claimReward: "領取",
  cinema_claiming: "領取中",
  cinema_taskClaimFailed: "領取失敗，請稍後重試",
  cinema_bindEmailAction: "去繫結",
  cinema_limitedRechargeTaskExpired: "已過期",
  cinema_watchHistory: "觀看歷史",
  cinema_navSearch: "搜尋劇集...",
  cinema_login: "登入",
  cinema_navProfile: "我的",
  cinema_vip: "會員",
  cinema_heroPlay: "立即播放",
  cinema_heroMore: "瞭解更多",
  cinema_hotRecommend: "熱門推薦",
  cinema_carouselLoading: "輪播內容載入中...",
  cinema_newRelease: "新劇上線",
  cinema_allSeries: "全部劇集",
  cinema_viewAll: "檢視全部",
  cinema_episodes: "共 {{count}} 集",
  cinema_rating: "{{score}} 分",
  cinema_views: "{{count}} 次觀看",
  cinema_play: "播放",
  cinema_continueWatch: "繼續觀看",
  cinema_rewatch: "重新觀看",
  cinema_categoryAll: "全部",
  cinema_categoryUrban: "都市情感",
  cinema_categorySuspense: "懸疑探案",
  cinema_categoryCostume: "古裝穿越",
  cinema_categoryWorkplace: "職場逆襲",
  cinema_categorySciFi: "科幻冒險",
  cinema_categorySciFiRomance: "科幻愛情",
  cinema_unlock: "解鎖劇集",
  cinema_unlockDesc: "解鎖本集需要消耗 {{cost}} 金幣",
  cinema_unlockConfirm: "確認解鎖並播放",
  cinema_cancel: "取消",
  cinema_balance: "當前餘額：{{coins}} 金幣",
  cinema_insufficient: "金幣不足，請先充值",
  cinema_unlocked: "已解鎖",
  cinema_locked: "未解鎖",
  cinema_episodeNumber: "第 {{number}} 集",
  cinema_playing: "播放中",
  cinema_backToList: "返回列表",
  cinema_back: "返回",
  cinema_noSeries: "暫無劇集",
  cinema_seriesDesc: "劇情介紹",
  cinema_episodeList: "選集",
  cinema_nextEpisode: "下一集",
  cinema_episodeEnded: "本集已播放完畢",
  cinema_nextEpisodePrompt: "是否繼續播放第 {{number}} 集？",
  cinema_playNextEpisode: "播放下一集",
  cinema_prevEpisode: "上一集",
  cinema_freeLabel: "免費",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "新劇",
  cinema_hotLabel: "熱門",
  cinema_featuredBanner: "本週必看",
  cinema_watchNow: "立即觀看",
  cinema_searchPlaceholder: "搜尋你感興趣的劇集...",
  cinema_noResults: "未找到相關劇集",
  cinema_emptyMyList: "還沒有熱播內容，去首頁看看吧",
  cinema_emptyHistory: "還沒有觀看記錄",
  cinema_addToMyList: "加入片單",
  cinema_removeFromMyList: "移出片單",
  cinema_clearAll: "清空全部",
  cinema_footerCopy: "黃果TV — 精品短劇平臺",
  cinema_footerWarning: "本平臺內容由AI生成，僅供娛樂。請遵守當地法律法規。",
  cinema_myList: "熱播劇場",
  cinema_addedAt: "{{date}}新增",
  cinema_expand: "展開",
  cinema_collapse: "收起",
  cinema_historyAll: "全部",
  cinema_historyUnfinished: "未看完",
  cinema_historyFinished: "已看完",
  cinema_historyCount: "共 {{count}} 條記錄",
  cinema_noHistoryFilter: "該分類下暫無記錄",
  cinema_finished: "已看完",
  cinema_watchedFull: "已全部看完",
  cinema_welcomeBack: "歡迎回來",
  cinema_loginDesc: "登入後解鎖更多精彩內容",
  cinema_phoneLogin: "手機號登入",
  cinema_emailLogin: "郵箱登入",
  cinema_phonePlaceholder: "請輸入手機號",
  cinema_emailPlaceholder: "請輸入郵箱地址",
  cinema_agreeTerms: "登入即表示同意",
  cinema_userAgreement: "《使用者協議》",
  cinema_privacyPolicy: "《隱私政策》",
  cinema_getCode: "獲取驗證碼",
  cinema_loginNow: "立即登入",
  cinema_otherLogin: "其他登入方式",
  cinema_loggingIn: "登入中...",
  cinema_loginSuccess: "登入成功",
  cinema_loginRedirect: "即將跳轉至個人中心...",
  cinema_profile: "個人中心",
  cinema_memberLabel: "會員",
  cinema_dealerLabel: "分銷商",
  cinema_coinAmount: "{{count}} 金幣",
  cinema_profileAccount: "賬戶管理",
  cinema_profileContent: "內容管理",
  cinema_profileSettings: "設定",
  cinema_editProfile: "編輯資料",
  cinema_myCoins: "我的金幣",
  cinema_myPurchases: "已購劇集",
  cinema_downloads: "離線下載",
  cinema_playbackSettings: "播放設定",
  cinema_notifications: "訊息通知",
  cinema_cacheManage: "快取管理",
  cinema_about: "聯絡我們",
  cinema_contactUnavailable: "線上客服暫不可用，請稍後再試",
  cinema_watchedHours: "觀看時長(小時)",
  cinema_collectionCount: "收藏劇集",
  cinema_logout: "退出登入",
  cinema_logoutConfirm: "確認退出？",
  cinema_logoutConfirmDesc: "退出後需要重新登入才能使用完整功能",
  cinema_version: "版本 {{version}}",
  cinema_rechargeTitle: "金幣充值",
  cinema_rechargeSubtitle: "請選擇充值套餐",
  cinema_rechargeVpnWarning: "VPN 或代理網路可能觸發支付風控，導致收銀臺無法開啟或支付失敗。",
  cinema_rechargeVpnGuideTitle: "支付前請先關閉 VPN",
  cinema_rechargeVpnInstruction: "關閉 VPN 後，再點選下方按鈕繼續使用已選擇的支付通道。",
  cinema_rechargeVpnContinue: "我已關閉 VPN，繼續支付",
  cinema_rechargeRMB: "人民幣充值",
  cinema_rechargeUSDT: "USDT 充值",
  cinema_rechargeRecommended: "推薦",
  cinema_rechargeCoins: "金幣",
  cinema_rechargeBonus: "+{{points}}金幣",
  cinema_rechargeCredited: "到賬 {{points}}",
  cinema_firstRechargeBannerTitle: "首充福利！首次充值任意金額額外加贈",
  cinema_firstRechargeSelectedBonus: "本次加贈 {{points}} 金幣",
  cinema_firstRechargeLimitedTitle: "限時首充福利",
  cinema_dailyRechargeLimitedTitle: "限時充值福利",
  cinema_firstRechargeLimitedBonus: "任意金額額外加贈 {{percent}}%",
  cinema_rechargePayMethod: "支付方式",
  cinema_rechargePay: "支付",
  cinema_rechargeNoPackages: "暫未配置可用套餐",
  cinema_paymentUnavailable: "支付暫不可用，請聯絡管理員",
  cinema_follow: "關注",
  cinema_collect: "收藏",
  cinema_share: "分享",
  cinema_loading: "載入中...",
  cinema_favorites: "我的收藏",
  cinema_emptyFavorites: "還沒有收藏劇集",
  cinema_emptyPurchases: "還沒有已購劇集",
  cinema_clearAllConfirm: "確認清空全部觀看記錄嗎？",
  cinema_episodesUnit: "集",
  cinema_lastWatched: "上次觀看第 {{episode}} 集",
  cinema_purchasedEpisodes: "已解鎖 {{count}} 集",
  cinema_account: "賬戶資訊",
  cinema_accountName: "暱稱",
  cinema_accountEmail: "郵箱",
  cinema_shareCode: "分享碼",
  cinema_saveProfile: "儲存資料",
  cinema_profileSaved: "資料已儲存",
  cinema_profileSaveFailed: "儲存資料失敗",
  cinema_accountInfo: "基本資料",
  cinema_changePassword: "修改密碼",
  cinema_newPassword: "新密碼",
  cinema_confirmPassword: "確認新密碼",
  cinema_passwordHint: "密碼至少需要6位",
  cinema_passwordMismatch: "兩次輸入的密碼不一致",
  cinema_passwordSaved: "密碼修改成功",
  cinema_passwordSaveFailed: "密碼修改失敗",
  cinema_savePassword: "儲存新密碼",
  cinema_pointsBalance: "當前金幣",
  cinema_coinLedger: "金幣流水",
  cinema_businessReference: "業務關聯",
  cinema_emptyPointLogs: "還沒有金幣流水",
  cinema_pointLog_registerReward: "註冊獎勵",
  cinema_pointLog_appFirstLoginReward: "APP首次登入獎勵",
  cinema_pointLog_inviteReward: "邀請獎勵",
  cinema_pointLog_dailyCheckIn: "每日簽到獎勵",
  cinema_pointLog_limitedRechargeTask: "限時首充任務獎勵",
  cinema_pointLog_emailBindingTask: "繫結郵箱任務獎勵",
  cinema_pointLog_dailyUnlockTask: "每日解鎖任務獎勵",
  cinema_bindEmailTaskTitle: "綁定信箱",
  cinema_dailyUnlockTaskTitle: "解鎖{{count}}集新劇集",
  cinema_unlockAction: "去解鎖",
  cinema_dailyTaskProgress: "今日進度 {{current}}/{{target}}（第1集不計）",
  cinema_pointLog_firstEpisodeUnlock: "解鎖首集權益",
  cinema_pointLog_episodeUnlock: "解鎖劇集",
  cinema_pointLog_recharge: "充值到賬",
  cinema_pointLog_firstRechargeBonus: "首充福利加贈",
  cinema_pointLog_dailyRechargeBonus: "限時充值福利加贈",
  cinema_pointLog_adminAdjust: "後臺調整",
  cinema_pointLog_other: "金幣變動",
  cinema_pointBiz_register: "使用者註冊",
  cinema_pointBiz_registerBackfill: "註冊獎勵補發",
  cinema_pointBiz_appFirstLogin: "APP首次登入",
  cinema_pointBiz_inviteRegister: "邀請註冊",
  cinema_pointBiz_dailyCheckIn: "每日簽到",
  cinema_pointBiz_legacyLimitedRechargeTask: "24小時充值任務",
  cinema_pointBiz_limitedRechargeTask: "1小時首充任務",
  cinema_pointBiz_emailBindingTask: "繫結郵箱任務",
  cinema_pointBiz_unlockThreeEpisodes: "每日解鎖3集任務",
  cinema_pointBiz_unlockFiveEpisodes: "每日解鎖5集任務",
  cinema_pointBiz_episodeUnlock: "劇集解鎖",
  cinema_pointBiz_rechargeOrder: "充值訂單",
  cinema_pointBiz_adminAdjust: "後臺調整",
  cinema_pointBiz_other: "其他業務",
  cinema_playbackAutoplay: "自動播放下一集",
  cinema_playbackAutoplayDesc: "當前劇集播放完成後自動進入下一集",
  cinema_aboutDesc: "黃果TV為你提供持續更新的短劇內容。",
  cinema_rechargeOrders: "充值流水",
  cinema_myRechargeRecords: "檢視我的充值記錄",
  cinema_totalInvites: "累計邀請",
  cinema_distributionStats: "推廣統計",
  cinema_distributionStatsDesc: "按時間檢視瀏覽、註冊、充值與佣金資料",
  cinema_summaryDate: "日期",
  cinema_summaryBrowse: "瀏覽",
  cinema_summaryRegister: "註冊",
  cinema_summaryRechargeCount: "充值筆數",
  cinema_conversionRate: "註冊轉化率",
  cinema_commissionRatio: "佣金比例",
  cinema_browseDetails: "瀏覽明細",
  cinema_browseTime: "瀏覽時間",
  cinema_browseDrama: "瀏覽影片",
  cinema_browseRegion: "地區",
  cinema_noBrowseData: "還沒有瀏覽記錄",
  cinema_noSummaryData: "還沒有匯總資料",
  cinema_rewarded: "已獎勵",
  cinema_registered: "已註冊",
  cinema_close: "關閉",
  cinema_emptyRechargeOrders: "還沒有充值記錄",
  cinema_rechargeRecords: "充值流水",
  cinema_commissionRecords: "分成流水",
  cinema_rechargeTime: "充值時間",
  cinema_paymentMethod: "支付方式",
  cinema_paymentStatus: "支付狀態",
  cinema_orderNo: "訂單號",
  cinema_noRechargeRecords: "還沒有充值流水",
  cinema_commissionTime: "分成時間",
  cinema_commissionLevel: "分成層級",
  cinema_commissionRate: "分成比例",
  cinema_noCommissionRecords: "還沒有分成流水",
  cinema_search: "查詢",
  cinema_reset: "重置",
  cinema_previousPage: "上一頁",
  cinema_nextPage: "下一頁",
  cinema_paymentStatus_created: "已建立",
  cinema_paymentStatus_pending: "待支付",
  cinema_paymentStatus_paid: "充值成功",
  cinema_paymentStatus_failed: "支付失敗",
  cinema_paymentStatus_closed: "已關閉",
  cinema_paymentStatus_expired: "已過期",
  cinema_paymentAwaiting: "訂單已建立，請在支付頁面完成支付。如果失敗，請檢查是否關閉 VPN",
  cinema_usdtAddress: "收款地址",
  cinema_usdtNetwork: "僅支援 TRC20 網路",
  cinema_copy: "複製",
  cinema_copied: "已複製",
  cinema_playerSettings: "播放設定",
  cinema_playerQuality: "清晰度",
  cinema_playerSpeed: "播放速度",
  cinema_playerAuto: "自動",
  cinema_playerSource: "原畫",
  cinema_playerSubtitles: "字幕",
  cinema_subtitleAuto: "自動字幕",
  cinema_subtitleOff: "關閉字幕",
  cinema_appDownloadTitle: "下一集用 App 看更穩",
  cinema_appDownloadDesc: "自動記住進度，更新時提醒你回來。",
  cinema_appDownloadReward: "下載 APP，首次登入額外贈送 {{points}} 金幣！",
  cinema_homeAppDownloadReward: "App首登送{{points}}金幣！",
  cinema_shareEarnPoints: "分享得金幣",
  cinema_shareLinkLabel: "分享連結",
  cinema_shareRewardUnlimited: "每分享一名使用者加入，你將獲取 {{points}} 金幣，分享無上限！",
  cinema_loginForShareLink: "登入並獲取分享連結",
  cinema_viewReferralStats: "檢視推廣情況",
  cinema_episodeFinished: "本集播放完畢",
  cinema_unlockNextEpisode: "解鎖下一集",
  cinema_changeDrama: "更換影片",
  cinema_allUnlocked: "已全部解鎖",
  cinema_appDownloadButton: "下載 App",
  cinema_appDownloadUnavailable: "暫未提供下載地址",
  cinema_rechargeAppPromptTitle: "下載 App 領金幣",
  cinema_rechargeAppPromptReward: "下載 App 並登入，額外贈送 {{points}} 金幣！",
  cinema_rechargeAppPromptDesc: "使用 App 觀看更穩定，還能自動儲存觀看進度。",
  cinema_appDownloadQr: "掃碼下載 App",
  cinema_ageGateBadge: "年齡驗證",
  cinema_ageGateTitle: "成人內容提示",
  cinema_ageGateDescription: "本網站包含僅適合成年人的 AI 生成虛構內容。繼續訪問即表示您確認已年滿 18 週歲，並同意遵守所在地法律法規。",
  cinema_ageGateUnderage: "未滿 18 週歲請立即離開。",
  cinema_ageGateConfirm: "我已年滿 18 週歲，進入網站",
  cinema_creatorCenter: "創作者中心",
  cinema_creatorCenterDesc: "把你的故事搬上黃果TV，作品透過稽核後將在影城上架，讓千萬觀眾看到你的才華，並享受高額度訂閱分成。",
  cinema_creatorCenterNote: "注：非原創作品必須無水印",
  cinema_creatorMemberReady: "您已是會員，可一鍵申請入駐",
  cinema_creatorBecome: "成為一名創作者",
  cinema_creatorGateDesc: "把你的故事搬上黃果TV，作品透過稽核後將在影城上架，讓千萬觀眾看到你的才華，並享受高額度訂閱分成。",
  cinema_creatorApplyBtn: "立即申請成為創作者",
  cinema_creatorBenefitTitle: "創作者權益",
  cinema_creatorBenefit1: "作品上架影城，並帶有專屬「原創」標籤",
  cinema_creatorBenefit2: "實時檢視作品展示量、訂閱量與收益分成",
  cinema_creatorBenefit3: "解鎖更多創作工具與推廣資源，更快變現",
  cinema_creatorReviewTip: "申請與作品均經平臺稽核，內容需符合社群規範。",
  cinema_creatorLevel: "認證創作者",
  cinema_creatorOriginal: "原創",
  cinema_creatorSince: "入駐於",
  cinema_creatorAddWork: "上傳新作品",
  cinema_creatorTabOverview: "資料總覽",
  cinema_creatorTabWorks: "我的作品",
  cinema_creatorTabUpload: "上傳作品",
  cinema_creatorTabPlatform: "創作平臺",
  cinema_creatorSubmitted: "提交成功，正在等待平臺稽核",
  cinema_creatorStatViews: "總展示量",
  cinema_creatorStatSubs: "總訂閱量",
  cinema_creatorStatRevenue: "累計分成",
  cinema_creatorStatWithdraw: "可提現",
  cinema_creatorStatWorks: "作品總數",
  cinema_creatorStatReview: "稽核中",
  cinema_creatorStatRejected: "未透過",
  cinema_creatorTopWork: "表現最佳的作品",
  cinema_creatorViews: "展示量",
  cinema_creatorSubscriptions: "訂閱量",
  cinema_creatorShare: "分成",
  cinema_creatorNoPublished: "還沒有已上架的作品",
  cinema_creatorFilterPublished: "已上架",
  cinema_creatorFilterReview: "稽核中",
  cinema_creatorFilterRejected: "未透過",
  cinema_creatorWorksTitle: "我的作品",
  cinema_creatorNoWorks: "還沒有作品，快去上傳第一部吧",
  cinema_creatorGoUpload: "去上傳",
  cinema_creatorStatusPublished: "已上架",
  cinema_creatorStatusReview: "稽核中",
  cinema_creatorStatusApproved: "等待轉碼",
  cinema_creatorStatusTranscoding: "轉碼中",
  cinema_creatorStatusReady: "等待發布",
  cinema_creatorStatusTranscodeFailed: "轉碼失敗",
  cinema_creatorStatusPublishFailed: "釋出失敗",
  cinema_creatorStatusRejected: "未透過",
  cinema_creatorPublishedOn: "上架於",
  cinema_creatorSubmittedOn: "提交於",
  cinema_creatorRejectedTip: "未透過 · 提交於",
  cinema_creatorWorkName: "作品名稱",
  cinema_creatorWorkNamePh: "請輸入作品名稱",
  cinema_creatorCategory: "題材分類",
  cinema_creatorCover: "作品封面",
  cinema_creatorCoverHint: "請上傳一張豎版作品封面",
  cinema_creatorCoverUrlPh: "貼上圖片連結（可選）",
  cinema_creatorSynopsis: "劇情簡介",
  cinema_creatorSynopsisPh: "用一兩句話介紹你的故事，讓觀眾一眼看懂…",
  cinema_creatorEpisodeTitle: "劇集資訊",
  cinema_creatorEpisodeDesc: "每一集都要填寫標題，並分別上傳一個 MP4 影片",
  cinema_creatorEpisodeTitlePh: "本集標題",
  cinema_creatorEpisodeDurPh: "時長(分)",
  cinema_creatorAddEpisode: "新增劇集",
  cinema_creatorEpShort: "第{{count}}集",
  cinema_creatorEpisodeUpload: "上傳 MP4",
  cinema_creatorEpisodeUploading: "上傳中…",
  cinema_creatorEpisodeReplace: "替換影片",
  cinema_creatorEpisodeMp4Only: "僅支援 .mp4 檔案，單個檔案最大 100MB",
  cinema_creatorEpisodeTypeError: "每一集只能上傳 .mp4 影片",
  cinema_creatorEpisodeSizeError: "單個劇集影片不能超過 100MB",
  cinema_creatorEpisodeUploadFailed: "劇集影片上傳失敗，請稍後重試",
  cinema_creatorEpisodeRequired: "請填寫每一集標題並上傳對應的 MP4 影片",
  cinema_creatorRequired: "請填寫作品名稱並選擇封面後再提交",
  cinema_creatorWorkNameRequired: "請填寫作品名稱",
  cinema_creatorCategoryRequired: "請選擇題材分類",
  cinema_creatorCoverRequired: "請上傳作品封面",
  cinema_creatorEpisodeTitleRequired: "請填寫本集標題",
  cinema_creatorEpisodeVideoRequired: "請上傳本集 MP4 影片",
  cinema_creatorSubmit: "提交稽核",
  cinema_creatorPlatformTag: "創作者推薦",
  cinema_creatorPlatformTitle: "創作工具平臺",
  cinema_creatorPlatformDesc: "前往官方創作平臺，使用更多專業創作工具、劇本靈感與素材庫，讓好故事更快成型並一鍵投稿。",
  cinema_creatorPlatformPoint1: "AI 劇本與靈感",
  cinema_creatorPlatformPoint2: "專業創作與上傳工具",
  cinema_creatorPlatformPoint3: "流量扶持與收益結算",
  cinema_creatorPlatformOpen: "前往創作平臺",
  cinema_creatorEarnBannerTitle: "把你的故事搬上影城",
  cinema_creatorEarnBannerDesc: "成為創作者，上傳作品，賺取豐厚的現金分成收益！",
  cinema_creatorEarnBannerBtn: "進入創作者中心",
  cinema_creatorApplyFailed: "申請失敗，請稍後重試",
  cinema_creatorSubmitFailed: "提交失敗，請稍後重試",
  cinema_creatorSubmitting: "提交中…",
  cinema_creatorCategoryEmpty: "暫無可用分類",
  cinema_creatorCoverUpload: "上傳封面",
  cinema_creatorCoverUploading: "上傳中…",
  cinema_creatorCoverChoose: "選擇圖片",
  cinema_creatorCoverReplace: "替換圖片",
  cinema_creatorCoverRemove: "移除",
  cinema_creatorCoverFormat: "支援 JPG、PNG、WebP、GIF，最大 10MB，只能上傳一張。",
  cinema_creatorCoverTypeError: "請選擇 JPG、PNG、WebP 或 GIF 圖片",
  cinema_creatorCoverSizeError: "封面圖片不能超過 10MB",
  cinema_creatorCoverUploadFailed: "封面上傳失敗，請稍後重試",
  cinema_creatorUploadNoticeTitle: "作品上傳說明",
  cinema_creatorUploadNotice1: "上傳資源無論是否原創，必須是AI類作品且無水印。",
  cinema_creatorUploadNotice2: "原創作品相對轉發作品分成更高。",
  cinema_creatorUploadNotice3: "劇集價格由平臺評級並最終決定！",
  cinema_creatorUploadNotice4: "單集時長不得少於150秒。",
  cinema_creatorUploadNoticeConfirm: "我已瞭解，繼續上傳",
};
